import utils from './utils';

import style from './components/style';
import menu from './components/menu';
import slider from './components/slider';
import accordion from './components/accordion';
import map from './components/map';
import product from './components/product';
import woocommerce from './components/woocommerce';
import checkout from './components/checkout';
import modals from './components/modals';
import lightgallery from './components/lightgallery';
function initHiPriorityCommon() {
}

function initLowPriorityCommon() {
    setTimeout(function() {

    }, 800);
}

function initPage() {
    console.log('initPage');
	style.init();
	slider.init();
    menu.init();
    accordion.init();
    map.init();
    product.init();
    woocommerce.init();
    checkout.init();
	lightgallery.initGallery();
	modals.initModal();
}

// document.addEventListener( 'DOMContentLoaded', function () {
utils.domReady(function () {
	initHiPriorityCommon();
	initPage();
	initLowPriorityCommon();
});
